import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Button, Link, Tippy } from '@superops/ui-design-system';
// import { showFeatureVideoPopup, getArticleLink } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import {
  COMMON_CONSTANTS,
  featureIdentifyObj,
  getTranslatedText,
  useIntl,
  useProduct
} from '@nile/components';
import { useFlags } from 'launchdarkly-react-client-sdk';

const FeatureGuide = (props) => {
  const {
    video,
    featureName,
    article,
    label,
    onlyIcon,
    showGuide,
    hideVideoGuide
  } = props;
  const flags = useFlags();
  const intl = useIntl();
  const isITProduct = useProduct(COMMON_CONSTANTS.IT);
  const clickVideoGuide = () => {
    if (featureIdentifyObj[featureName]?.videoLink) {
      const url = featureIdentifyObj[featureName]?.videoLink;
      window.open(url, '_blank');
    } else if (flags?.appcuseVideo) {
      window.CommandBar.trackEvent(featureIdentifyObj[featureName]?.id, {});
    } else {
      window?.Appcues?.show(featureIdentifyObj[featureName]?.appcuseId);
    }

    // window.CommandBar.trackEvent(featureIdentifyObj[featureName]?.id, {});
  };
  if (isITProduct && !showGuide) {
    return <></>;
  }

  let articleLink = featureIdentifyObj[featureName]?.article;

  if (isITProduct && featureIdentifyObj[featureName]?.itArticle) {
    articleLink = featureIdentifyObj[featureName]?.itArticle;
  }

  return flags?.featureGuideVideo ? (
    <div className="flex actr g20">
      {(article ? article && articleLink : articleLink) &&
        (onlyIcon ? (
          <div className="fx center ignoreOverride">
            <Link url={articleLink} external>
              <Tippy
                interactive
                title={getTranslatedText(
                  intl,
                  featureIdentifyObj[featureName]?.tooltipInfoArticle ??
                    'common.article'
                )}
              >
                <SVGIcon color="#3586FF" name="Notes" />
              </Tippy>
            </Link>
          </div>
        ) : (
          <Button
            url={articleLink}
            external
            // Uncomennt the below code to open article inside Intercom
            // onClick={() =>
            //   window?.Intercom(
            //     'showArticle',
            //     featureIdentifyObj[featureName]?.articleId
            //   )
            // }
            icon={
              <div className="fx center ignoreOverride">
                <SVGIcon name="Notes" />
              </div>
            }
            plain
          >
            <FormattedMessage
              id={
                featureIdentifyObj[featureName]?.guideArticleLabel ??
                'common.article'
              }
            />
          </Button>
        ))}
      {!hideVideoGuide &&
        (video
          ? video && featureIdentifyObj[featureName]?.id
          : featureIdentifyObj[featureName]?.id) &&
        (onlyIcon ? (
          <div
            className="fx center ptr ignoreOverride"
            onClick={clickVideoGuide}
          >
            <Tippy
              interactive
              title={getTranslatedText(
                intl,
                featureIdentifyObj[featureName]?.tooltipInfoVideo ??
                  'common.video'
              )}
            >
              <SVGIcon name="VideoSolid" color="#3586FF" size="lg" />
            </Tippy>
          </div>
        ) : (
          <Button
            plain
            icon={
              <div className="fx center ignoreOverride">
                <SVGIcon color="red" name="Video" />
              </div>
            }
            onClick={clickVideoGuide}
          >
            <FormattedMessage
              id={
                featureIdentifyObj[featureName]?.guideVideoLabel ??
                'common.video'
              }
            />
          </Button>
        ))}
    </div>
  ) : null;
};

export { FeatureGuide };
